<template>
  <div>
    <div class="d-flex justify-content-between mb-1">
      <h4>{{ labelTitle }}</h4>
      <b-button variant="outline-primary" @click="onContactAdd">
        เพิ่มข้อมูลติดต่อ
      </b-button>
    </div>

    <b-row v-for="(item, key) in contacts" :key="key">
      <b-col cols="12" md="4">
        <b-form-group>
          <b-form-select v-model="item.contactTypeId" :options="contactTypes" />
        </b-form-group>
      </b-col>
      <b-col cols="10" md="6">
        <b-form-group>
          <ValidationProvider
            rules="required"
            name="ข้อมูลติดต่อ"
            v-slot="{ errors }"
          >
            <b-form-input
              v-model="item.description"
              placeholder="กรุณากรอก ข้อมูลติดต่อ"
            />
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>
      </b-col>
      <b-col md="2" class="d-flex justify-content-center">
        <a
          href="javascript:void(0)"
          class="text-danger"
          @click="onContactDelete(key)"
        >
          <feather-icon icon="Trash2Icon" size="24" />
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormInput,
  BFormGroup,
  BFormSelect,
} from "bootstrap-vue";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import * as storeMaster from "@/store/api/master/index.js";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormInput,
    BFormGroup,
    BFormSelect,
    ValidationProvider,
  },
  props: {
    labelTitle: "",
    contacts: [],
    isClue: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      contactTypes: [],
    };
  },
  created() {
    if (this.isClue === true) {  
      this.getClueContactType();
    } else {
      this.getComplaintContactType();
    }
  },
  methods: {
    getComplaintContactType() {
      const _this = this;
      storeMaster
        .getComplaintContactType()
        .then(function(response) {
          _this.contactTypes = response.data.data;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onContactAdd() {
      let cts = this.contacts;
      cts.push({ contactTypeId: 2, description: "" });

      this.$emit("handleChanged", cts);
    },
    onContactDelete(key) {
      try {
        console.log('key', key)
        let cts = this.contacts
        if (key > -1) {
          cts.splice(key, 1); // 2nd parameter means remove one item only
        }

        this.$emit("handleChanged", cts);
      } catch (ex) {
        console.log(ex);
      }
    },
    getClueContactType() {
      const _this = this;
      storeMaster
        .getClueContactType()
        .then(function(response) {
          _this.contactTypes = response.data.data;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
  },
};
</script>

<style></style>
